package system.single

import b2d.*
import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import com.soywiz.korge.box2d.*
import component.*
import system.*

class FinishSystem(
    worldMetaData: WorldMetaData = inject(),
    private val onPlayerFinished: (Int) -> Unit,
    private val sessionData: SessionData = inject()
) : IteratingSystem(family { all(PlayerComponent) }) {

    private val finish = worldMetaData.finishArea.body!!.getFixtureList()?.userData as Finish

    override fun onTickEntity(entity: Entity) {
        if (finish.getFinishedPlayers().isNotEmpty()) {
            val playerComp = entity[PlayerComponent]

            println("finish system check")

            this.enabled = false
            sessionData.isPaused = true

            onPlayerFinished(playerComp.playerMetadata.playerPhysicState.coinsCount)
        }
    }
}
